/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';
import {
    type GetTasksResponse,
    GetTasksResponseFromJSON,
    GetTasksResponseToJSON,
} from '../models/GetTasksResponse';
import {
    type PollResponse,
    PollResponseFromJSON,
    PollResponseToJSON,
} from '../models/PollResponse';
import {
    type TaskDetailsRequestParams,
    TaskDetailsRequestParamsFromJSON,
    TaskDetailsRequestParamsToJSON,
} from '../models/TaskDetailsRequestParams';
import {
    type TaskRequestParams,
    TaskRequestParamsFromJSON,
    TaskRequestParamsToJSON,
} from '../models/TaskRequestParams';

export interface GetTaskDetailsRequest {
    params: TaskDetailsRequestParams;
}

export interface GetTasksRequest {
    params: TaskRequestParams;
}

export interface PollForUpdatesRequest {
    params: TaskDetailsRequestParams;
}

/**
 * 
 */
export class TaskControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for getTaskDetails without sending the request
     */
    async getTaskDetailsRequestOpts(requestParameters: GetTaskDetailsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['params'] == null) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter "params" was null or undefined when calling getTaskDetails().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['params'] != null) {
            queryParameters['params'] = requestParameters['params'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/db-scheduler-api/tasks/details`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getTaskDetailsRaw(requestParameters: GetTaskDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTasksResponse>> {
        const requestOptions = await this.getTaskDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTasksResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTaskDetails(requestParameters: GetTaskDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTasksResponse> {
        const response = await this.getTaskDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getTasks without sending the request
     */
    async getTasksRequestOpts(requestParameters: GetTasksRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['params'] == null) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter "params" was null or undefined when calling getTasks().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['params'] != null) {
            queryParameters['params'] = requestParameters['params'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/db-scheduler-api/tasks/all`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getTasksRaw(requestParameters: GetTasksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTasksResponse>> {
        const requestOptions = await this.getTasksRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTasksResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTasks(requestParameters: GetTasksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTasksResponse> {
        const response = await this.getTasksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for pollForUpdates without sending the request
     */
    async pollForUpdatesRequestOpts(requestParameters: PollForUpdatesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['params'] == null) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter "params" was null or undefined when calling pollForUpdates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['params'] != null) {
            queryParameters['params'] = requestParameters['params'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/db-scheduler-api/tasks/poll`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async pollForUpdatesRaw(requestParameters: PollForUpdatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PollResponse>> {
        const requestOptions = await this.pollForUpdatesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PollResponseFromJSON(jsonValue));
    }

    /**
     */
    async pollForUpdates(requestParameters: PollForUpdatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PollResponse> {
        const response = await this.pollForUpdatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
